import { useRef, useEffect, useLayoutEffect } from 'react';

function useRandomClassName() {
  const randomId = Math.random().toString(36).substring(2, 10);
  return `__m__-${randomId}`;
}
function useWindowEvent(type, listener, options) {
  useEffect(() => {
    window.addEventListener(type, listener, options);
    return () => window.removeEventListener(type, listener, options);
  }, [type, listener]);
}
function useDidUpdate(fn, dependencies) {
  const mounted = useRef(false);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
  useEffect(() => {
    if (mounted.current) {
      return fn();
    }
    mounted.current = true;
    return void 0;
  }, dependencies);
}
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function useUnmount(func) {
  const funcRef = useRef(func);
  funcRef.current = func;
  useEffect(
    () => () => {
      funcRef.current();
    },
    []
  );
}

export { useDidUpdate, useIsomorphicLayoutEffect, useRandomClassName, useUnmount, useWindowEvent };
